import React from 'react';
import { Tag } from 'components/ui';
import { showStats } from './utils';

const GmailAccountStats = ({
  num_pending,
  revoked,
  suspended_at,
  as_reply_to,
}) => {
  const show = showStats({ num_pending, revoked, suspended_at, as_reply_to });

  if (show) {
    return (
      <Tag
        color="#108ee9"
        style={{
          fontWeight: 'lighter',
          fontSize: 10,
          marginLeft: 5,
          color: 'white',
        }}
      >
        {num_pending} pending
      </Tag>
    );
  }

  return <></>;
};

export default GmailAccountStats;
